import ajax from '@/resources/myApi';
import vm from '@/main';

const service = {
  getCurrencyTypes,
  manageCurrencyTypes,
  deleteCurrencyTypes,
};

async function getCurrencyTypes() {
  try {
    const { data } = await ajax.get(`api/CurrencyType`, {
      name: 'Currency Types',
      params: { pageNumber: 0, pageSize: 1 },
    });
    return data.items;
  } catch (error) {
    console.log('API Catch:',error.message);
    return { items: [], paging: {} };
  }
}

async function manageCurrencyTypes(dto) {
  try {
    if (dto.id) {
      var { data } = await ajax.put(`api/CurrencyType/${dto.id}`, {
        name: 'Currency Type',
        body: dto,
      });
    } else {
      var { data } = await ajax.post(`api/CurrencyType`, {
        name: 'Currency Type',
        body: dto,
      });
    }

    if (data.id) {
      vm.$snotify.success((dto.id) ? 'Currency Type changes saved' : 'Currency Type has been created', 'Currency Type');
      return data.id;
    }
  } catch (error) {
    console.log('API Catch:',error.message);
    return {}
  }
}

async function deleteCurrencyTypes(id) {
  try {
    await ajax.delete(`api/CurrencyType/${id}`);
    vm.$snotify.success('Currency Type has been removed', 'Currency Type');
  } catch (error) {
    console.log('API Catch:',error.message);
  }
}

export default service;
